// extracted by mini-css-extract-plugin
export default {"videoSection":"VideoSection_videoSection__ankW6","videoContent":"VideoSection_videoContent__2gdSP","videoContainer":"VideoSection_videoContainer__XqDnj"};